import { API_MAP, agent } from 'helpers';
class CurrencyService {
  static listCurrency() {
    return agent.get(`${API_MAP.listCurrency}`);
  }
}
export default CurrencyService;
